// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scoped styles for Update Control page */

.ucp-container { padding: 1rem; }
/* Constrain and center the form for better readability */
.ucp-container form { max-width: 1100px; }

/* Map Tailwind-like widths */
.w-90 { width: 90% !important; }

/* Spacing helpers */
.mt-5px { margin-top: 5px; }

/* Headings */
.ucp-section-title { font-size: 1rem; font-weight: 600; margin-bottom: .25rem; }

/* React Select alignment fix inside Bootstrap form layout */
.react-select-container { width: 100%; }
.react-select-container > div { min-height: 40px; border-color: #ced4da; box-shadow: none; }
.react-select-container > div:hover { border-color: #86b7fe; }
.react-select-container .ucp__control { min-height: 40px; }
.react-select-container .ucp__value-container { padding: 2px 8px; }
.react-select-container .ucp__indicators { height: 40px; }

/* Table tweaks */
.ucp-table thead tr { background: #ffbe99; }
.ucp-table td, .ucp-table th { vertical-align: middle; }

/* Separator substitute */
.ucp-separator { border-top: 1px solid #e5e7eb; margin: 1rem 0; }

/* Form elements default look */
.ucp-container .form-control,
.ucp-container .form-select {
  border-color: #ced4da;
  border-radius: .5rem;
}

.ucp-container .form-control:focus,
.ucp-container .form-select:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 .2rem rgba(13,110,253,.15);
}

/* Buttons sizing in inline groups */
.ucp-container .btn { border-radius: .5rem; }
.ucp-container .btn svg { vertical-align: middle; }

/* Input group styling for add/remove buttons */
.ucp-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ucp-input-group .form-control,
.ucp-input-group .react-select-container {
  flex: 1 1;
}

.ucp-input-group .btn {
  flex-shrink: 0;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.ucp-input-group .btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}

.ucp-input-group .btn-outline-danger:hover {
  background-color: #dc3545;
  color: white;
}

.ucp-input-group .btn-outline-primary {
  color: #0d6efd;
  border-color: #0d6efd;
}

.ucp-input-group .btn-outline-primary:hover {
  background-color: #0d6efd;
  color: white;
}

/* Add reference button style */
.add-reference-button {
  background-color: #d56423;
  border-color: #d56423;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.add-reference-button:hover {
  background-color: #c55a1f;
  border-color: #c55a1f;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(213, 100, 35, 0.3);
}

.add-reference-button svg {
  margin-right: 4px;
}

/* Form group with flex layout */
.form-group-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 1rem;
}

.form-group-flex .form-control,
.form-group-flex .react-select-container {
  flex: 1 1;
  min-width: 0;
}

/* Ensure buttons align properly with inputs */
.form-group-flex .btn {
  flex-shrink: 0;
  align-self: center;
}

/* Row layout for form groups */
.form-row-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 1rem;
}

.form-row-flex .form-control,
.form-row-flex .react-select-container {
  flex: 1 1;
  min-width: 0;
}

.form-row-flex .btn {
  flex-shrink: 0;
  align-self: center;
}

/* Section blocks */
.ucp-block { background: #fff; border: 1px solid #e9ecef; border-radius: .75rem; padding: 1rem; margin-bottom: 1rem; }
.ucp-block-title { font-weight: 600; margin-bottom: .5rem; }

/* Remove borders from specific inputs */
.form-control.no-border {
    border: none !important;
    box-shadow: none !important;
}

.form-control.no-border:focus {
    border: none !important;
    box-shadow: none !important;
}

/* Remove borders from react-select components */
.react-select-container .no-border {
    border: none !important;
    box-shadow: none !important;
}

.react-select-container .no-border:focus {
    border: none !important;
    box-shadow: none !important;
}

/* All add buttons - orange color with text */
.risk-add-button,
.process-add-button,
.function-add-button {
    background-color: #d56423 !important;
    border: 1px solid #d56423 !important;
    color: white !important;
    height: 40px;
    min-width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.risk-add-button:hover,
.process-add-button:hover,
.function-add-button:hover {
    background-color: #c55a1f !important;
    border-color: #c55a1f !important;
    color: white !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(213, 100, 35, 0.3);
}

.risk-add-button:active,
.process-add-button:active,
.function-add-button:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(213, 100, 35, 0.3);
}


`, "",{"version":3,"sources":["webpack://./src/pages/referenes/updateControl.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C,iBAAiB,aAAa,EAAE;AAChC,yDAAyD;AACzD,sBAAsB,iBAAiB,EAAE;;AAEzC,6BAA6B;AAC7B,QAAQ,qBAAqB,EAAE;;AAE/B,oBAAoB;AACpB,UAAU,eAAe,EAAE;;AAE3B,aAAa;AACb,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;;AAE/E,4DAA4D;AAC5D,0BAA0B,WAAW,EAAE;AACvC,gCAAgC,gBAAgB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC3F,sCAAsC,qBAAqB,EAAE;AAC7D,wCAAwC,gBAAgB,EAAE;AAC1D,gDAAgD,gBAAgB,EAAE;AAClE,2CAA2C,YAAY,EAAE;;AAEzD,iBAAiB;AACjB,sBAAsB,mBAAmB,EAAE;AAC3C,+BAA+B,sBAAsB,EAAE;;AAEvD,yBAAyB;AACzB,iBAAiB,6BAA6B,EAAE,cAAc,EAAE;;AAEhE,+BAA+B;AAC/B;;EAEE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,oCAAoC;AACpC,sBAAsB,oBAAoB,EAAE;AAC5C,0BAA0B,sBAAsB,EAAE;;AAElD,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB,aAAa,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACrH,mBAAmB,gBAAgB,EAAE,oBAAoB,EAAE;;AAE3D,wCAAwC;AACxC;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,gDAAgD;AAChD;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,6CAA6C;AAC7C;;;IAGI,oCAAoC;IACpC,oCAAoC;IACpC,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;IAGI,oCAAoC;IACpC,gCAAgC;IAChC,uBAAuB;IACvB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,wBAAwB;IACxB,6CAA6C;AACjD","sourcesContent":["/* Scoped styles for Update Control page */\n\n.ucp-container { padding: 1rem; }\n/* Constrain and center the form for better readability */\n.ucp-container form { max-width: 1100px; }\n\n/* Map Tailwind-like widths */\n.w-90 { width: 90% !important; }\n\n/* Spacing helpers */\n.mt-5px { margin-top: 5px; }\n\n/* Headings */\n.ucp-section-title { font-size: 1rem; font-weight: 600; margin-bottom: .25rem; }\n\n/* React Select alignment fix inside Bootstrap form layout */\n.react-select-container { width: 100%; }\n.react-select-container > div { min-height: 40px; border-color: #ced4da; box-shadow: none; }\n.react-select-container > div:hover { border-color: #86b7fe; }\n.react-select-container .ucp__control { min-height: 40px; }\n.react-select-container .ucp__value-container { padding: 2px 8px; }\n.react-select-container .ucp__indicators { height: 40px; }\n\n/* Table tweaks */\n.ucp-table thead tr { background: #ffbe99; }\n.ucp-table td, .ucp-table th { vertical-align: middle; }\n\n/* Separator substitute */\n.ucp-separator { border-top: 1px solid #e5e7eb; margin: 1rem 0; }\n\n/* Form elements default look */\n.ucp-container .form-control,\n.ucp-container .form-select {\n  border-color: #ced4da;\n  border-radius: .5rem;\n}\n\n.ucp-container .form-control:focus,\n.ucp-container .form-select:focus {\n  border-color: #86b7fe;\n  box-shadow: 0 0 0 .2rem rgba(13,110,253,.15);\n}\n\n/* Buttons sizing in inline groups */\n.ucp-container .btn { border-radius: .5rem; }\n.ucp-container .btn svg { vertical-align: middle; }\n\n/* Input group styling for add/remove buttons */\n.ucp-input-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ucp-input-group .form-control,\n.ucp-input-group .react-select-container {\n  flex: 1;\n}\n\n.ucp-input-group .btn {\n  flex-shrink: 0;\n  height: 40px;\n  width: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.ucp-input-group .btn-outline-danger {\n  color: #dc3545;\n  border-color: #dc3545;\n}\n\n.ucp-input-group .btn-outline-danger:hover {\n  background-color: #dc3545;\n  color: white;\n}\n\n.ucp-input-group .btn-outline-primary {\n  color: #0d6efd;\n  border-color: #0d6efd;\n}\n\n.ucp-input-group .btn-outline-primary:hover {\n  background-color: #0d6efd;\n  color: white;\n}\n\n/* Add reference button style */\n.add-reference-button {\n  background-color: #d56423;\n  border-color: #d56423;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.add-reference-button:hover {\n  background-color: #c55a1f;\n  border-color: #c55a1f;\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(213, 100, 35, 0.3);\n}\n\n.add-reference-button svg {\n  margin-right: 4px;\n}\n\n/* Form group with flex layout */\n.form-group-flex {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 1rem;\n}\n\n.form-group-flex .form-control,\n.form-group-flex .react-select-container {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Ensure buttons align properly with inputs */\n.form-group-flex .btn {\n  flex-shrink: 0;\n  align-self: center;\n}\n\n/* Row layout for form groups */\n.form-row-flex {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 1rem;\n}\n\n.form-row-flex .form-control,\n.form-row-flex .react-select-container {\n  flex: 1;\n  min-width: 0;\n}\n\n.form-row-flex .btn {\n  flex-shrink: 0;\n  align-self: center;\n}\n\n/* Section blocks */\n.ucp-block { background: #fff; border: 1px solid #e9ecef; border-radius: .75rem; padding: 1rem; margin-bottom: 1rem; }\n.ucp-block-title { font-weight: 600; margin-bottom: .5rem; }\n\n/* Remove borders from specific inputs */\n.form-control.no-border {\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.form-control.no-border:focus {\n    border: none !important;\n    box-shadow: none !important;\n}\n\n/* Remove borders from react-select components */\n.react-select-container .no-border {\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.react-select-container .no-border:focus {\n    border: none !important;\n    box-shadow: none !important;\n}\n\n/* All add buttons - orange color with text */\n.risk-add-button,\n.process-add-button,\n.function-add-button {\n    background-color: #d56423 !important;\n    border: 1px solid #d56423 !important;\n    color: white !important;\n    height: 40px;\n    min-width: 120px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 12px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.risk-add-button:hover,\n.process-add-button:hover,\n.function-add-button:hover {\n    background-color: #c55a1f !important;\n    border-color: #c55a1f !important;\n    color: white !important;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(213, 100, 35, 0.3);\n}\n\n.risk-add-button:active,\n.process-add-button:active,\n.function-add-button:active {\n    transform: translateY(0);\n    box-shadow: 0 1px 2px rgba(213, 100, 35, 0.3);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
